<template name="component-name">
    <div>
        <v-card
            :style="cssVars"
            height="80"
            width="720px"
            flat
            class="pa-10  rounded-lg d-flex justify-center align-center border"
        >
            <template v-for="item in items">
                <v-avatar
                    :style="cssVars"
                    :key="item.id"
                    v-bind:class="[
                        selectedStep === item.id ? 'selected' : 'unselected',
                        selectedStep > item.id ? 'stepcomplete' : '',
                        selectedStep < item.id ? 'border' : 'unborder'
                    ]"
                >
                    <v-icon
                        :style="cssVars"
                        v-bind:class="[
                            item.icon,
                            selectedStep === item.id
                                ? 'selectedIcon'
                                : 'unselectedIcon'
                        ]"
                        >{{ item.icon }}</v-icon
                    >
                </v-avatar>

                <h5
                    :style="cssVars"
                    :key="item.label"
                    class="ml-2 mt-3 mr-4 textStep"
                >
                    {{ item.label }}
                </h5>
            </template>
        </v-card>
    </div>
</template>
<script>
export default {
    data: () => ({
        selected: false
    }),
    props: ['color', 'selectedStep', 'items'],
    computed: {
        cssVars() {
            return {
                '--bg-color': this.color
            }
        }
    },

    watch: {
        steps(val) {
            if (this.e1 > val) {
                this.e1 = val
            }
        }
    },

    methods: {
        nextStep(n) {
            if (n === this.steps) {
                this.e1 = 1
            } else {
                this.e1 = n + 1
            }
        }
    }
}
</script>
<style scoped>
.border {
    border: 0.2px solid var(--bg-color) !important;
}
.unborder {
    border: none;
}
.selectedIcon {
    color: #fff !important;
}

.unselectedIcon {
    color: var(--bg-color);
}

.selected {
    background-color: var(--bg-color);
}
.unselected {
    background-color: #fff;
}
.stepcomplete {
    background-color: #f2faf4;
    border: none;
}

.textStep {
    font-family: 'Inter';
    font-weight: 600;
    font-size: 14px !important;
    color: var(--bg-color) !important;
}
::v-deep .v-card > *:first-child:not(.v-btn):not(.v-chip),
.v-card > .v-card__progress + *:not(.v-btn):not(.v-chip) {
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
}

::v-deep .v-card > *:last-child:not(.v-btn):not(.v-chip) {
    border-bottom-left-radius: 50%;
    border-bottom-right-radius: 50%;
}
</style>
